import { VueQueryPlugin } from '@tanstack/vue-query'
import { createQueryClient } from '@erpx/ui'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { setMfaRequiredHandler, setSessionLostHandler } from './api/session'
import { i18n } from './i18n'
import { createAppRouter } from './router'
import { useAuthStore } from './stores/auth'
import './styles/app.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// Before the router: `afterEach` translates the document title, so the
// catalogue has to be installed by the time the first navigation resolves.
app.use(i18n)

const router = createAppRouter()
app.use(router)

app.use(VueQueryPlugin, {
  queryClient: createQueryClient(),
})

const auth = useAuthStore(pinia)

/**
 * The two session-level outcomes any request can produce, wired once here
 * rather than handled per screen: the server telling us MFA enrolment is owed
 * (§6), and a refresh that could not be recovered.
 */
setMfaRequiredHandler(() => {
  if (router.currentRoute.value.name !== 'mfa-enrol') void router.push({ name: 'mfa-enrol' })
})

setSessionLostHandler(() => {
  auth.clear()
  if (router.currentRoute.value.name !== 'login') {
    void router.push({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    })
  }
})

app.mount('#app')
